import React from 'react';
import styles from '../Operations.module.css';

interface MPTCComponent extends React.FC {
  title?: string;
  kpiHyperlink?: string;
  isDisclaimerRequired?: boolean;
}

/**
 * MPTCOMPLETION - MPT - % Completion
 * KPI information component
 */
const MPTC: MPTCComponent = () => {
  return (
    <div className={styles.container}>
      <div className={styles.sectionTitle}>Metric Description</div>

      <div className={styles.sectionContent}>
        The Marketing Planning Tool provides an automated and comprehensive process to create a tailored annual marketing budget, track monthly performance, and take action when necessary.
      </div>

      <div className={styles.sectionTitle}>Supporting Details</div>

      <div className={styles.sectionContent}>
        <ul>
          <li>On an annual basis, on or after October 5 and prior to end of year, build your upcoming year’s marketing plan</li>
          <li>As needed, provide ACENET access to all new users that will be utilizing MPT</li>
          <li>For new stores, complete the New Store Marketing tactics for building a marketing plan. Also, enter new co-op claims and review existing ones</li>
        </ul>
      </div>

      <div className={styles.sectionTitle}>Goal</div>

      <div className={styles.sectionContent}>
        The goal is to build your annual marketing plan at 100%.
      </div>

      <div className={styles.sectionTitle}>Drill Down</div>

       <div className={styles.sectionContent}>
        Marketing budgeting tactics covered under the Marketing Planning Tool include: 
      </div>

      <div className={styles.sectionContent}>
        <ol>
          <li>Ace Rewards</li>
          <li>SOCi</li>
          <li>National Circulars</li>
          <li>Famous 4 Four and Sign Kits</li>
          <li>Other Local Marketing (TV/cable/radio ads, billboards, run of press, print jobs, sponsorships, etc.)</li>
          <li>Grand Opening Events (New stores)</li>
        </ol>
      </div>

      <div className={styles.sectionTitle}>Learn More</div>

      <div className={styles.sectionContent}>
        <ol>
          <li>Set up Marketing Planning Tool User Access</li>
          <li>Build Your Marketing Plan</li>
          <li>Review Dashboard and Analytics for Applicable Marketing Tactics (Monthly)</li>
          <li>Review and Manage Co-op and Vendor Credits</li>
        </ol>
        <br />
        For detailed step-by-step directions review the Ace Way of Retailing <a
          href="https://acenet.aceservices.com/awor/marketing-planning/marketing-planning-tool"
          target="_blank"
          rel="noopener noreferrer"
          className={styles.link}>
          Marketing Planning Tool Store Procedure Doc
        </a>
      </div>
    </div>
  );
};

MPTC.title = 'MPT - % Completion – Marketing Planning Tool';
export default MPTC;
